var _path, _path2, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1500,
    height: 935,
    viewBox: "0 0 1500 935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.9090909090909918,0.3785425101214628)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 935,
    width: 1500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,83.98180418410043,47.215199999999996)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.55639163179913 152.7696",
    height: 152.7696,
    width: 227.55639163179913,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.55639163179913 152.7696",
    height: 152.7696,
    width: 227.55639163179913,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.5563916317992 152.76960000000003",
    height: 152.7696,
    width: 227.55639163179913,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.5563916317992 152.76960000000003",
    height: 152.76960000000003,
    width: 227.5563916317992,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.5563916317992 152.76960000000003",
    height: 152.76960000000003,
    width: 227.5563916317992,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.5563916317992 152.76960000000003",
    height: 152.76960000000003,
    width: 227.5563916317992,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 227.5563916317992,
    viewBox: "3.25 -35.01 52.14 35.01",
    height: 152.76960000000003,
    "data-palette-color": "#2a2c35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.76-7.01L27.76 0 3.25 0 3.25-35.01 10.25-35.01 10.25-7.01 27.76-7.01ZM55.39-7.01L55.39 0 31.39 0 31.39-35.01 55.39-35.01 55.39-28 38.4-28 38.4-21 49.9-21 49.9-13.99 38.4-13.99 38.4-7.01 55.39-7.01Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#2a2c35",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.283 41.215L266.283 0 19.083 0 19.083 247.2 266.283 247.2 266.283 205.985 252.506 205.985 252.506 233.423 32.86 233.423 32.86 13.777 252.506 13.777 252.506 41.215Z",
    fill: "#2a2c35",
    stroke: "transparent",
    "data-fill-palette-color": "primary"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d063dcc56c2e94326d370a3b356f80aa.svg";
export { ForwardRef as ReactComponent };